import { Location } from '@angular/common';
import { Component, Input, OnChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from '@app/core/services/application/application.service';
import { FormService } from '@app/core/services/form/form.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { WarningService } from '@core/services/warning/warning.service';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons';
import { faBriefcaseMedical } from '@fortawesome/pro-solid-svg-icons';
import json from 'assets/content/text.json';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

interface reviewQuestion {
    sortorder: number;
    type: string;
    question: string;
    publicshow: boolean;
    default?: string;
}

@Component({
    selector: 'app-review',
    templateUrl: './application-review.component.html',
    styleUrls: ['./application-review.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationReviewComponent implements OnChanges {
    @Input() status: any;
    @Input() reviewType: any;

    sliderOpts = {
        initialSlide: 0,
        speed: 400,
        scrollbar: true,
        slidesPerView: 1,
        centeredSlides: true,
    };

    icons: any = {
        case: faBriefcaseMedical,
        calendar: faCalendarDay,
    };

    images = [];

    constructor(
        private router: Router,
        private warning: WarningService,
        private lct: Location,
        private route: ActivatedRoute,
        public toolService: ToolService,
        private applicationService: ApplicationService
    ) {}

    review: any = {
        rating: 0,
        satisfaction: 0,
        starCount: 5,
        one: 60,
        two: 60,
        three: 60,
        four: 60,
        five: 60,
        six: 60,
        seven: 60,
        eight: 60,
        nine: 60,
    };

    questions: any = [];
    content = json;
    loading = false;
    initloading = true;
    review_form: FormGroup;

    reviewQuestions: reviewQuestion[] = [];

    queriedQuestions: any;

    noQuestions = false;

    ngOnChanges(): void {
        if (this.status) {
            this.applicationService.showReviewsQuestions(this.status.application.id, this.reviewType).subscribe((response: any) => {
                this.queriedQuestions = typeof response.questions === 'string' ? JSON.parse(response.questions) : response.questions;

                this.reviewQuestions = this.queriedQuestions.map((q) => {
                    return q;
                });

                const orderAdditional = this.reviewQuestions.length;

                this.reviewQuestions.push(
                    {
                        sortorder: orderAdditional + 4,
                        type: 'number',
                        question: 'Please indicate your level of satisfaction with the AMO team and resources provided.',
                        publicshow: false,
                        default: 'satisfaction',
                    },
                    {
                        sortorder: orderAdditional + 5,
                        type: 'number',
                        question: 'Overall, how would you rate your experience?',
                        publicshow: false,
                        default: 'rating',
                    }
                );

                let group = {};
                this.reviewQuestions.forEach((input) => {
                    if (input.type === 'number') {
                        group[input.question] = new FormControl(0, Validators.compose([Validators.required]));
                    } else if (input.type === 'string') {
                        group[input.question] = new FormControl(
                            '',
                            Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(550)])
                        );
                    } else {
                        group[input.question] = new FormControl('', Validators.required);
                    }
                });

                this.review_form = new FormGroup(group);

                // get the users first name;
                var first = this.status.user.name.substr(0, this.status.user.name.indexOf(' '));
                //set proper name case
                var firstName = first.substring(0, 1).toUpperCase() + first.substring(1).toLowerCase();
                this.review_form.addControl('name', new FormControl(firstName));
                this.review_form.addControl('programid', new FormControl(this.status.application.programid));
                this.review_form.addControl('userid', new FormControl(this.status.application.userid));
                this.review_form.addControl('programlocation', new FormControl(this.status.application.programlocation));
                this.review_form.addControl('date', new FormControl(this.status.application.enddate));

                this.initloading = false;
            }),
                (err) => {
                    this.initloading = false;
                    this.noQuestions = true;
                };
        }
        if (this.status.application.program) {
            if (this.status.application.program.image.length > 0) {
                this.status.application.program.image.forEach((image) => {
                    const arr = [];
                    if (image.size === 'md') {
                        arr.push(image);
                        this.images.push(arr);
                    }
                });
            }
        }
    }

    submit = (): void => {
        this.loading = true;

        if (this.review_form.valid) {
            const modReviewObject = { ...this.review_form.value };
            const defaultReviews = this.reviewQuestions.filter((a) => {
                return a.default;
            });

            defaultReviews.forEach((a) => {
                if (this.review_form.value[a.question]) {
                    modReviewObject[a.default] = this.review_form.value[a.question];
                    modReviewObject[a.default] =
                        modReviewObject[a.default] === 'true' ? true : modReviewObject[a.default] === 'false' ? false : modReviewObject[a.default];
                    delete modReviewObject[a.question];
                }
            });

            modReviewObject.type = this.reviewType;
            modReviewObject.applicationid = this.status.application.id;

            this.applicationService
                .reviewApplication(this.status.application.id, {
                    form: modReviewObject,
                    questions: this.queriedQuestions,
                })
                .subscribe(
                    (response: any) => {
                        if (response.type === 'danger') {
                            this.warning.create(response.message);
                            setTimeout(() => {
                                this.loading = false;
                            }, 3000);
                        } else {
                            const url = this.router.createUrlTree(['/application', this.status.application.id], { relativeTo: this.route }).toString();
                            this.lct.replaceState(url);
                            location.reload();
                        }
                    },
                    (error: any) => {
                        this.loading = false;
                        if (error.error.message.includes('Review Already Exists')) {
                            this.warning.create('You have already submitted a review for this application. Please contact support to move forward.');
                            const url = this.router.createUrlTree(['/application', this.status.application.id], { relativeTo: this.route }).toString();
                            this.lct.replaceState(url);
                            location.reload();
                        }
                    }
                );
        } else {
            this.warning.create('Please complete all the questions for this review.').then(() => {
                this.loading = false;
            });
        }
    };

    onRatingChanged(val: any) {
        this.review.rating = val;
        this.review_form.patchValue({
            rating: val,
        });
    }

    onSatisfactionChanged(rating: any) {
        this.review.satisfaction = rating;
        this.review_form.patchValue({
            satisfaction: rating,
        });
    }

    // input for question 1
    inputChanged(event: any, num: string) {
        const max = 500;
        const diff = Math.abs(event.detail.value.replace(/ /g, '').length - max);
        this.review[num] = diff;
    }
}
